import Home from "@/components/Home.vue";
import Activities from "@/components/Activities.vue";
import Agenda from "@/components/Agenda.vue";
import Classrooms from "@/components/Classrooms.vue";
import IconLibraries from "@/components/IconLibraries.vue";
import IconLibrary from "@/components/IconLibrary.vue";
import Pupils from "@/components/Pupils.vue";
import Users from "@/components/Users.vue";
import ActivityBoard from "@/components/ActivityBoard.vue";
import ActivityBoardStartScreen from "@/components/ActivityBoardStartScreen.vue";
import ActivityBoardSetupInfo from "@/components/ActivityBoardSetupInfo.vue";
import Organisations from "@/components/Organisations.vue";
import Observations from "@/components/Observations.vue";
import Insights from "@/components/Insights.vue";
import PageNotFound from "@/components/PageNotFound.vue";
import Preferences from "@/components/Preferences.vue";
import NetworkError from "@/components/NetworkError.vue";
import SelectOrganisation from "@/components/SelectOrganisation.vue";
import GoalCollections from "@/components/GoalCollections.vue";
import GoalCollection from "@/components/GoalCollection.vue";
import CurriculumTableImport from "@/components/CurriculumTableImport.vue";
import CurriculumTableToJson from "@/components/CurriculumTableToJson.vue";
import LessonPlanLibrary from "@/components/LessonPlanLibrary.v2.vue";
import LessonPlanMyLibrary from "@/components/LessonPlanMyLibrary.vue";
import LessonPlanDiscover from "@/components/LessonPlanDiscover.vue";
import LessonPlanDiscoverHome from "@/components/LessonPlanDiscoverHome.vue";
import LessonPlanDiscoverAuthor from "@/components/LessonPlanDiscoverAuthor.vue";
import LessonPlanDiscoverAuthorGroup from "@/components/LessonPlanDiscoverAuthorGroup.vue";
import ReflectionBoard from "@/components/ReflectionBoard.vue";
import Goals from "@/components/Goals.vue";
import SchoolSettings from "@/components/SchoolSettings.vue";
import PupilReport from "@/components/PupilReport.vue";

export const routes = [
	{
		name: 'home',
		path: '/',
		component: Home,
	},
	{
		name: 'organisation.select',
		path: '/select-organisation',
		component: SelectOrganisation,
	},
	{
		name: 'user.list',
		path: '/users',
		component: Users,
		meta: {
			permissions: 'admin'
		}
	},
	{
		name: 'schools.list',
		path: '/schools',
		component: Organisations,
		meta: {
			permissions: 'superadmin'
		}
	},
	{
		name: 'icon-library.list',
		path: '/icon-libraries',
		component: IconLibraries,
		props: {
			// TODO: use 'organisation' instead, in line with other components
			scope: 'global'
		},
		meta: {
			permissions: 'admin'
		}
	},
	{
		name: 'icon-library.view',
		path: '/icon-libraries/:libraryId',
		component: IconLibrary,
		props: {
			// TODO: use 'organisation' instead, in line with other components
			scope: 'global'
		},
		meta: {
			permissions: 'admin'
		}
	},
	{
		name: 'classroom.list',
		path: '/classrooms',
		component: Classrooms,
		meta: {
			permissions: 'admin,not-superadmin'
		}
	},
    {
		path: '/goal-collections',
		meta: {
			permissions: 'admin,not-superadmin'
		},
		children: [
			{
				name: 'goal-collections',
				path: '',
				component: GoalCollections
			},

			{
				name: 'goal-collections.collection',
				path: '/goal-collections/:collectionId',
				component: GoalCollection,
				meta: {
					permissions: 'admin'
				}
			},

		]
	},

    {
		name: 'curriculum.table-import',
		path: '/curriculum/table-import',
		component: CurriculumTableImport,
		meta: {
			permissions: 'admin'
		}
	},
    {
		name: 'curriculum.table-to-json',
		path: '/curriculum/table-to-json',
		component: CurriculumTableToJson,
		meta: {
			permissions: 'admin'
		}
	},

	{
		name: 'pupil.list',
		path: '/pupils',
		component: Pupils,
		props: {
			scope: 'organisation'
		},
		meta: {
			permissions: 'admin,not-superadmin'
		}
	},

	{
		name: 'pupil.report',
		path: '/pupils/:pupilId/report',
		component: PupilReport,
		meta: {
			permissions: 'teacher'
		}
	},

	{
		name: 'school-settings',
		path: '/settings',
		component: SchoolSettings,
		meta: {
			permissions: 'admin,not-superadmin'
		}
	},

	{
		name: 'classroom.goal.list',
		path: '/classrooms/:classroomId/goals',
		component: Goals,
		meta: {
			permissions: 'teacher'
		}
	},

	{
		name: 'classroom.pupil.list',
		path: '/classrooms/:classroomId/pupils',
		component: Pupils,
		props: {
			scope: 'classroom'
		},
		meta: {
			permissions: 'teacher'
		}
	},
	{
		name: 'classroom.activity.list',
		path: '/classrooms/:classroomId/activities',
		component: Activities,
		meta: {
			permissions: 'teacher'
		}
	},

	{
		path: '/lesson-plan-library',
		component: LessonPlanLibrary,
		meta: {
			permissions: 'teacher',
		},

		children: [
			{
				path: '',
				redirect: { name: 'lesson-plan-library.my-library' }
			},
			{
				name: 'lesson-plan-library.my-library',
				path: 'my-library',
				component: LessonPlanMyLibrary,
				props: { readOnly: false },
				meta: {
					permissions: 'teacher',
				}
			},
			{
				name: 'lesson-plan-library.my-library.collection',
				path: 'my-library/collection/:collectionId',
				component: LessonPlanMyLibrary,
				props: route => ({ readOnly: false, selectedCollectionId: route.params.collectionId }),
				meta: {
					permissions: 'teacher',
				}
			},

			{
				path: 'discover',
				component: LessonPlanDiscover,
				meta: {
					permissions: 'teacher',
				},
				children: [
					{
						name: 'lesson-plan-library.discover.home',
						path: '',
						component: LessonPlanDiscoverHome,
						meta: {
							permissions: 'teacher',
						},
					},
					{
						name: 'lesson-plan-library.discover.colleague',
						path: 'colleague/:userId',
						component: LessonPlanDiscoverAuthor,
						props: route => ({ authorId: route.params.userId, section: 'colleagues' }),
						meta: {
							permissions: 'teacher',
						},
					},
					{
						name: 'lesson-plan-library.discover.author',
						path: 'author/:userId',
						component: LessonPlanDiscoverAuthor,
						props: route => ({ authorId: route.params.userId, section: 'public' }),
						meta: {
							permissions: 'teacher',
						},
					},
					{
						name: 'lesson-plan-library.discover.group',
						path: 'group/:groupId',
						component: LessonPlanDiscoverAuthorGroup,
						props: route => ({ groupId: route.params.groupId }),
						meta: {
							permissions: 'teacher',
						},
					},
				],
			},
		]
	},

	{
		name: 'classroom.icon-library.list',
		path: '/classrooms/:classroomId/icon-libraries',
		component: IconLibraries,
		props: {
			scope: 'classroom'
		},
		meta: {
			permissions: 'teacher',

		}
	},
	{
		name: 'classroom.icon-library.view',
		path: '/classrooms/:classroomId/icon-libraries/:libraryId',
		component: IconLibrary,
		props: {
			scope: 'classroom'
		},
		meta: {
			permissions: 'teacher'
		}
	},
	{
		name: 'classroom.agenda',
		path: '/classrooms/:classroomId/agenda',
		component: Agenda,
		meta: {
			permissions: 'teacher'
		}
	},
	{
		name: 'classroom.observation.list',
		path: '/classrooms/:classroomId/observations',
		component: Observations,
		meta: {
			permissions: 'teacher'
		}
	},
	{
		name: 'classroom.insights',
		path: '/classrooms/:classroomId/insights',
		component: Insights,
		meta: {
			permissions: 'teacher'
		},
		children: [
			{
				name: 'classroom.insights.activity',
				path: 'activity',
				component: Insights,
				meta: {
					permissions: 'teacher',
					report: 'activity'
				}
			},

			{
				name: 'classroom.insights.feedback',
				path: 'feedback',
				component: Insights,
				meta: {
					permissions: 'teacher',
					report: 'feedback'
				}
			},

			{
				name: 'classroom.insights.social',
				path: 'social',
				component: Insights,
				meta: {
					permissions: 'teacher',
					report: 'social'
				}
			},

			{
				name: 'classroom.insights.goals',
				path: 'goals',
				component: Insights,
				meta: {
					permissions: 'teacher',
					report: 'goals'
				}
			},
		]
	},

	// {
	// 	name: 'agenda',
	// 	path: '/',
	// 	component: Agenda
	// },
	{
		name: 'activity-board',
		path: '/activity-board',
		component: ActivityBoard,
		meta: {
			activityBoardConnect: true,
			pusherConnect: true,
		},
	},
	{
		name: 'activity-board-select',
		path: '/board',
		component: ActivityBoardStartScreen,
		meta: {
			guestAccess: true,
			pusherConnect: true,
		},
	},

	{
		name: 'reflection-board-today',
		path: '/reflection-board/today',
		component: ReflectionBoard,
		meta: {
			activityBoardConnect: true,
			pusherConnect: true,
			dateRange: 'today',
		}
	},

	{
		name: 'reflection-board-yesterday',
		path: '/reflection-board/yesterday',
		component: ReflectionBoard,
		meta: {
			activityBoardConnect: true,
			pusherConnect: true,
			dateRange: 'yesterday',
		}
	},

	{
		name: 'classroom.activity-board-setup-info',
		path: '/classrooms/:classroomId/activity-board-setup-info',
		component: ActivityBoardSetupInfo,
	},

	{
		name: 'user.preferences',
		path: '/preferences',
		component: Preferences,
	},

	{
		name: 'network-error',
		path: '/network-error',
		component: NetworkError,
		meta: {
			guestAccess: true
		},
	},

	{
		name: 'not-found',
		path: '/:pathMatch(.*)*',
		component: PageNotFound,
	},
];
